import { useCallback, useEffect, useState } from 'react';
import { axiosClient } from '../../auth-lib';

// One fetch of a firm's subscription, shared by the two screens that show it.
//
// ⚠️ `GET /subscription` (auth-service) returns the plan, the seat position AND
// any open request together, and every caller needs all three — a screen that
// knew the seat count but not the pending ask offered "request a larger plan" to
// somebody who asked yesterday. That is why there is no narrower `/seats`.
//
// ⚠️ This endpoint is deliberately UNGATED on the server: it is what a firm with
// no subscription reads to find out it has none. Do not put it behind anything.
export function useSubscription() {
  const [subscription, setSubscription] = useState(null);
  const [seats, setSeats] = useState(null);
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await axiosClient.get('/subscription');
      setSubscription(res.data.subscription);
      setSeats(res.data.seats);
      setOrganization(res.data.organization);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Could not load your subscription');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { subscription, seats, organization, loading, error, reload: load };
}

export default useSubscription;
